interface IAppConfig {
  baseUrl?: string;
  authUrl?: string;
  signalRUrl?: string;
}

export const appConfig: IAppConfig = {
  baseUrl: process.env.REACT_APP_BASE_API_URL,
  signalRUrl: process.env.REACT_APP_SIGNAL_R_URL,
  authUrl: process.env.REACT_APP_AUTH_URL,
};
